export const descendingSort = (arr: any, field: string) => {
  const sorted = arr.sort((a: any, b: any) => {
    if (a[field] > b[field]) return -1
    else if (a[field] < b[field]) return 1
    return 0
  })
  return sorted
}

export const ascendingSort = (arr: any, field: string) => {
  const sorted = arr.sort((a: any, b: any) => {
    if (a[field] > b[field]) return 1
    else if (a[field] < b[field]) return -1
    return 0
  })
  return sorted
}
